function bustMediaCache(url, updatedAt) {
  try {
    if (!updatedAt) {
      return url;
    }
    const urlObject = new URL(url);
    urlObject.searchParams.set("updatedAt", updatedAt || "");
    return urlObject.toString();
  } catch {
    return url;
  }
}
export {
  bustMediaCache as b
};
//# sourceMappingURL=media.DVNzFvj8.mjs.map
